/* ============================================
   Panier Museau & Co, le comportement commun au tiroir et à la page
   (porté du panier Rue des Plantes le 22-09-2026 ; même code, préfixe mc-).
   Relecture adverse du 22-09 : brainstorm/05-panier-tiroir/RELECTURE-1.md.

   Un seul écouteur par type d'événement, posé sur le document : le contenu
   du panier est remplacé à chaque mise à jour, rien n'est à rebrancher.

   Ce que fait ce fichier :
   - moins, plus, saisie de la quantité, « Retirer » : /cart/change.js avec
     la CLE de la ligne ;
   - « Ajouter » d'une suggestion : /cart/add.js ;
   - code de réduction : /cart/update.js (`discount`) ; Shopify dit lui-même
     si le code s'applique, le panier ne calcule rien ; les codes du panier
     sont lus une fois par action (réponse de /cart/change ou /cart/update,
     sinon une lecture de /cart.js : /cart/add.js ne les porte pas) ;
   - après toute erreur, recalage sur le serveur (rafraichir) ;
   - paliers : libellés calés sous leur rond, coche qui « pope » une fois au
     franchissement, remplissage qui glisse de sa position vers le nouveau total ;
   - code de réduction replié : un repli ouvert le reste après un rendu ;
   - à chaque réponse, les sections rendues par Shopify (tiroir, bulle de
     l'en-tête, page panier) remplacent l'ancien contenu : prix, total et
     paliers viennent toujours du serveur, jamais d'un calcul ici ;
   - « Compléter sa cure » : /recommendations/products (complementary, puis
     related), section mc-panier-suggestions.

   ARGENT : aucun prix, aucune remise, aucun seuil n'est calculé dans ce fichier.
   La remise Kaching Bundles du pilote Immunité (propriété __kaching_bundles)
   est appliquée par Shopify et lue dans les sections rendues, comme le reste.

   Les requêtes passent l'une après l'autre (file d'attente) : deux clics
   rapides sur « + » donnent 2 articles de plus, pas une course entre deux
   réponses.
   ============================================ */

(function () {
  if (window.McPanier) return;

  var routes = window.routes || {};
  var URL_CHANGE = (routes.cart_change_url || '/cart/change') + '.js';
  var URL_AJOUT = (routes.cart_add_url || '/cart/add') + '.js';
  var URL_MAJ = (routes.cart_update_url || '/cart/update') + '.js';
  var URL_PANIER = routes.cart_url || '/cart';

  var file = Promise.resolve();
  var cacheSuggestions = {};
  // Quantité demandée mais pas encore confirmée, par ligne : deux clics
  // rapides sur « + » partent de 1, 2, 3, pas de 1, 2 deux fois.
  var enAttente = {};
  // Retraits partis ou en file, par clé de ligne Shopify.
  var retraitsEnFile = {};

  // La CLE d'une ligne Shopify CHANGE quand sa quantité change (la clé suit
  // les remises appliquées ; relevé sur Rue des Plantes, revérifié ici par la
  // relecture du 22-09 avec deux lignes de la même variante). On repère donc
  // une ligne par sa variante et sa place, et on relit sa clé dans le DOM au
  // moment d'envoyer.
  function repereLigne(ligne) {
    var zone = ligne.closest('[data-mc-panier]');
    var lignes = Array.prototype.slice.call(zone.querySelectorAll('[data-mc-ligne]'));
    return { zone: zone.getAttribute('data-mc-panier'), variante: ligne.getAttribute('data-variante'), rang: lignes.indexOf(ligne), cle: ligne.getAttribute('data-cle'), identite: ligne.getAttribute('data-identite') };
  }

  // La CLÉ d'abord : si elle existe encore, c'est la ligne cliquée. Puis
  // l'IDENTITÉ (variante, plan, propriétés), qui ne suit pas les remises. Sinon
  // variante puis rang, SAUF pour un retrait (`strict`) : deviner par le rang retirait une AUTRE ligne de la
  // même variante après un retrait plus haut (l'abonnement à la place de
  // l'achat unique, RELECTURE-COMPACT-5.md, H2). Le pire, alors, est que la
  // ligne reste à l'écran, jamais qu'une autre parte.
  function retrouverLigne(rep, strict) {
    var zone = document.querySelector('[data-mc-panier="' + rep.zone + '"]');
    if (!zone) return null;
    if (rep.cle) {
      var parCle = zone.querySelector('[data-mc-ligne][data-cle="' + CSS.escape(rep.cle) + '"]');
      if (parCle) return parCle;
    }
    // Clé changée par une remise (un « + » ou une saisie passés juste avant) :
    // l'identité de la ligne (variante, plan, propriétés) ne bouge pas avec
    // la remise. Une seule ligne la porte : c'est elle. Sans cela, un retrait
    // cliqué juste après un « + » était ignoré sans un mot
    // (RELECTURE-COMPACT-6.md, J1).
    if (rep.identite) {
      var parIdentite = zone.querySelectorAll('[data-mc-ligne][data-identite="' + CSS.escape(rep.identite) + '"]');
      if (parIdentite.length === 1) return parIdentite[0];
    }
    if (strict) return null;
    var lignes = Array.prototype.slice.call(zone.querySelectorAll('[data-mc-ligne]'));
    var memes = lignes.filter(function (l) { return l.getAttribute('data-variante') === rep.variante; });
    if (memes.length === 1) return memes[0];
    var auRang = lignes[rep.rang];
    if (auRang && auRang.getAttribute('data-variante') === rep.variante) return auRang;
    return memes[0] || null;
  }

  function cleAttente(rep) {
    return rep.variante + '|' + rep.rang;
  }

  function enFile(tache) {
    file = file.then(tache, tache);
    return file;
  }

  function sectionsVoulues() {
    var ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer #CartDrawer')) ids.push('cart-drawer');
    var page = document.querySelector('[data-mc-panier="page"]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }

  function lire(html, selecteur) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selecteur);
  }

  // La région annoncée est HORS du contenu remplacé
  // (dans <cart-drawer> hors de #CartDrawer, et hors de #McPanierPage) : une
  // région live insérée puis remplie aussitôt n'est souvent pas lue.
  function annoncer(texte) {
    var tiroir = document.querySelector('cart-drawer');
    var cible = tiroir && tiroir.classList.contains('active')
      ? tiroir.querySelector('[data-mc-annonce-globale]')
      : document.querySelector('[data-mc-annonce-page]') || (tiroir && tiroir.querySelector('[data-mc-annonce-globale]'));
    if (!cible) return;
    cible.textContent = '';
    setTimeout(function () { cible.textContent = texte; }, 100);
  }

  function montrerErreur(racine, texte) {
    var cibles = racine ? [racine] : document.querySelectorAll('[data-mc-panier]');
    Array.prototype.forEach.call(cibles, function (r) {
      var el = r.querySelector('[data-mc-erreur]');
      if (!el) return;
      el.textContent = texte;
      el.hidden = false;
    });
    annoncer(texte);
  }

  // Mémorise quel contrôle avait le focus pour le rendre après le
  // remplacement du HTML (sinon le focus tombe sur <body> et un lecteur
  // d'écran ou un utilisateur au clavier perd sa place).
  // Un contrôle HORS des lignes (croix, case prioritaire, code, bouton
  // d'achat, suggestions) se retrouve par un sélecteur stable.
  function signature(el) {
    var attrs = ['data-mc-fermer', 'data-mc-priorite', 'data-mc-commander'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) return '[' + attrs[i] + ']';
    }
    if (el.matches('input[name="code"]')) return 'input[name="code"]';
    if (el.matches('summary.mc-code__ouvrir')) return 'summary.mc-code__ouvrir';
    if (el.matches('summary.mc-resume__livraison-ligne')) return 'summary.mc-resume__livraison-ligne';
    if (el.matches('[data-mc-livraison-choix]')) return '[data-mc-livraison-choix][value="' + CSS.escape(el.value) + '"]';
    if (el.matches('.mc-code__appliquer')) return '.mc-code__appliquer';
    var action = el.getAttribute('data-mc-action');
    if (action && !el.closest('[data-mc-ligne]')) {
      var sel = '[data-mc-action="' + action + '"]';
      ['data-code', 'data-variante'].forEach(function (a) {
        if (el.hasAttribute(a)) sel += '[' + a + '="' + CSS.escape(el.getAttribute(a)) + '"]';
      });
      return sel;
    }
    return null;
  }

  function reperFocus() {
    var actif = document.activeElement;
    if (!actif || !actif.closest) return null;
    var zone = actif.closest('[data-mc-panier]');
    if (!zone) return null;
    var ligne = actif.closest('[data-mc-ligne]');
    return {
      zone: zone.getAttribute('data-mc-panier'),
      ligne: ligne ? repereLigne(ligne) : null,
      action: actif.getAttribute('data-mc-action'),
      signature: ligne ? null : signature(actif),
    };
  }

  // Le champ de quantité n'est JAMAIS une cible de repli : un champ de saisie
  // qui prend le focus affiche toujours son cadre, même après un clic de
  // souris. Valentin, 23-09 : après un ajout au panier, « on dirait que ça
  // clique sur la quantité, ça fait un gros truc carré ». Cause : le recalage
  // qui suit l'ajout rendait le focus de la croix au premier contrôle de la
  // première ligne, donc au champ quand « − » est grisé (quantité 1).
  function rendreFocus(repere) {
    if (!repere) return;
    var zone = document.querySelector('[data-mc-panier="' + repere.zone + '"]');
    if (!zone) return;
    var cible = null;
    if (repere.signature) cible = zone.querySelector(repere.signature + ':not([disabled])');
    // Après un RETRAIT, le focus va sur le NOM de la ligne qui a pris la place
    // (ou de la dernière), jamais sur un bouton qui change le panier : la
    // poubelle d'une autre ligne (deux lignes de la même variante) retirait
    // un deuxième produit au second Entrée, et « + » en ajoutait un
    // (RELECTURE-COMPACT-1.md D1, RELECTURE-COMPACT-2.md E1, E2). Ailleurs, le
    // même contrôle (grisé compris), sinon le nom de la ligne.
    // « − » et « + » grisés restent focusables (aria-disabled) : le focus
    // reste sur le bouton pressé, il ne saute plus sur l'autre (F1). Une ligne
    // dont la CLÉ existe encore n'a pas été retirée : on lui rend le même
    // contrôle, poubelle comprise ; un focus qui était sur un nom revient sur
    // le nom (RELECTURE-COMPACT-3.md, G6).
    if (!cible && repere.ligne) {
      var memeCle = repere.ligne.cle && zone.querySelector('[data-mc-ligne][data-cle="' + CSS.escape(repere.ligne.cle) + '"]');
      var ligne = memeCle || (repere.action === 'retirer' ? null : retrouverLigne(repere.ligne));
      if (ligne) {
        cible = (repere.action && ligne.querySelector('[data-mc-action="' + repere.action + '"]:not([disabled])')) ||
          ligne.querySelector('.mc-ligne__nom');
      }
      if (!cible) {
        var noms = zone.querySelectorAll('.mc-panier__lignes .mc-ligne__nom');
        if (noms.length) cible = noms[Math.min(repere.ligne.rang, noms.length - 1)];
      }
    }
    if (!cible) cible = zone.querySelector('[data-mc-fermer], .mc-panier__vide a');
    if (cible) cible.focus({ preventScroll: true });
  }

  // ---------- Paliers : libellés sous leur rond, franchissement ----------

  var RANG = { aucun: 0, relais: 1, tous: 2 };

  function etatsPaliers() {
    var etats = {};
    document.querySelectorAll('[data-mc-panier]').forEach(function (zone) {
      var pal = zone.querySelector('[data-mc-paliers]');
      etats[zone.getAttribute('data-mc-panier')] = pal ? pal.getAttribute('data-etat') : null;
    });
    return etats;
  }

  // Les deux libellés sont posés en CSS sous leur rond ; sur un écran étroit
  // ils peuvent se toucher. On décale alors celui du point relais vers la
  // gauche, juste de ce qu'il faut (le banc vérifie qu'il reste sous son rond).
  function calerPaliers(racine) {
    (racine || document).querySelectorAll('[data-mc-paliers]').forEach(function (pal) {
      var relais = pal.querySelector('[data-mc-palier-libelle="relais"]');
      var domicile = pal.querySelector('[data-mc-palier-libelle="domicile"]');
      var ul = pal.querySelector('.mc-paliers__etapes');
      if (!relais || !domicile || !ul) return;
      relais.style.removeProperty('--mc-decalage');
      var a = relais.getBoundingClientRect();
      var b = domicile.getBoundingClientRect();
      var c = ul.getBoundingClientRect();
      if (!a.width) return;
      var decalage = 0;
      // Au moins 16 px entre les deux blocs (libellés d'une ligne depuis le
      // 06-10 : 24 px poussaient « Point relais offert » trop loin de son rond).
      var chevauche = a.right - (b.left - 16);
      if (chevauche > 0) decalage = -chevauche;
      if (a.left + decalage < c.left) decalage = c.left - a.left;
      if (decalage) relais.style.setProperty('--mc-decalage', Math.round(decalage) + 'px');
    });
  }

  function celebrer(avant) {
    var apres = etatsPaliers();
    var franchi = false;
    Object.keys(apres).forEach(function (cle) {
      if (!avant[cle] || !apres[cle]) return;
      if (RANG[apres[cle]] <= RANG[avant[cle]]) return;
      var pal = document.querySelector('[data-mc-panier="' + cle + '"] [data-mc-paliers]');
      if (!pal) return;
      franchi = true;
      var ronds = [];
      if (RANG[avant[cle]] < 1) ronds.push('relais');
      if (apres[cle] === 'tous') ronds.push('domicile');
      ronds.forEach(function (r) {
        var rond = pal.querySelector('[data-mc-palier-rond="' + r + '"]');
        if (rond) rond.classList.add('is-franchi');
      });
      pal.setAttribute('data-franchi', ronds.join(','));
      document.documentElement.setAttribute('data-mc-dernier-franchi', ronds.join(','));
    });
    if (franchi) {
      // Compteur lu par le banc : une célébration par franchissement.
      var n = parseInt(document.documentElement.getAttribute('data-mc-paliers-franchis') || '0', 10) + 1;
      document.documentElement.setAttribute('data-mc-paliers-franchis', String(n));
      var phrase = document.querySelector('[data-mc-panier] [data-mc-paliers-phrase]');
      if (phrase) setTimeout(function () { annoncer(phrase.textContent.replace(/\s+/g, ' ').trim()); }, 400);
    }
  }

  function noeudsPaliers() {
    var noeuds = {};
    document.querySelectorAll('[data-mc-panier]').forEach(function (zone) {
      var pal = zone.querySelector('[data-mc-paliers]');
      if (pal) noeuds[zone.getAttribute('data-mc-panier')] = pal;
    });
    return noeuds;
  }

  // Un nouveau rendu identique (même total, même état) garde l'ANCIENNE barre :
  // une coche en train de « poper » n'est pas coupée par le recalage qui suit.
  function garderPaliers(anciens) {
    Object.keys(anciens).forEach(function (cle) {
      var ancien = anciens[cle];
      var nouveau = document.querySelector('[data-mc-panier="' + cle + '"] [data-mc-paliers]');
      if (!nouveau || nouveau === ancien) return;
      if (nouveau.getAttribute('data-total') === ancien.getAttribute('data-total') &&
          nouveau.getAttribute('data-etat') === ancien.getAttribute('data-etat')) {
        nouveau.replaceWith(ancien);
      }
    });
  }

  // Le remplissage glisse (06-10) : chaque rendu pose la barre à sa place
  // finale ; on la repose un instant là où elle était, puis on la laisse
  // glisser jusqu'à la nouvelle (transition CSS). Rien si moins d'animations.
  // (Le camion qui roulait dessus a été retiré le soir même, à la demande de
  // Valentin.)
  function avancesPaliers() {
    var avances = {};
    document.querySelectorAll('[data-mc-panier]').forEach(function (zone) {
      // Pas encore de barre (panier vide) : le remplissage partira du début.
      // Sinon de là où il EST (il peut être en route après deux « + »
      // rapides), pas de là où il allait (RELECTURE-COMPACT-1.md, D16).
      var pal = zone.querySelector('[data-mc-paliers]');
      var avance = pal ? pal.getAttribute('data-avance') : '0';
      var rempli = pal && pal.querySelector('[data-mc-paliers-rempli]');
      var barre = pal && pal.querySelector('.mc-paliers__barre');
      if (rempli && barre && barre.clientWidth) {
        avance = String(Math.round((rempli.getBoundingClientRect().width / barre.clientWidth) * 10000) / 100);
      }
      avances[zone.getAttribute('data-mc-panier')] = avance;
    });
    return avances;
  }

  function glisserRemplissage(avant) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    Object.keys(avant).forEach(function (cle) {
      var pal = document.querySelector('[data-mc-panier="' + cle + '"] [data-mc-paliers]');
      if (!pal || !avant[cle] || Math.abs(Number(pal.getAttribute('data-avance')) - Number(avant[cle])) < 0.05) return;
      var rempli = pal.querySelector('[data-mc-paliers-rempli]');
      if (!rempli) return;
      var cible = pal.getAttribute('data-avance') + '%';
      rempli.style.width = avant[cle] + '%';
      pal.getBoundingClientRect();
      requestAnimationFrame(function () { rempli.style.width = cible; });
    });
  }

  // Le code de réduction est replié (06-10) : un repli ouvert le reste
  // d'un rendu à l'autre (sinon le champ disparaît sous les doigts après un
  // code refusé).
  // Même chose pour le dépli des tarifs de livraison (06-10 au soir).
  var REPLIS = ['[data-mc-code-repli]', '[data-mc-livraison-repli]'];

  function replisOuverts() {
    var ouverts = {};
    document.querySelectorAll('[data-mc-panier]').forEach(function (zone) {
      REPLIS.forEach(function (sel) {
        var repli = zone.querySelector(sel);
        if (repli && repli.open) ouverts[zone.getAttribute('data-mc-panier') + '|' + sel] = true;
      });
    });
    return ouverts;
  }

  function rouvrirReplis(ouverts) {
    Object.keys(ouverts).forEach(function (cle) {
      var parts = cle.split('|');
      var repli = document.querySelector('[data-mc-panier="' + parts[0] + '"] ' + parts[1]);
      if (repli) repli.open = true;
    });
  }

  function appliquerSections(sections, codes, relireCodesApres) {
    sections = sections || {};
    var repere = reperFocus();
    var avant = etatsPaliers();
    var anciensPaliers = noeudsPaliers();
    var avances = avancesPaliers();
    var ouverts = replisOuverts();

    var tiroir = document.querySelector('cart-drawer');
    if (tiroir && sections['cart-drawer'] && typeof tiroir.remplacer === 'function') {
      tiroir.remplacer(sections['cart-drawer']);
    }

    var bulle = document.getElementById('cart-icon-bubble');
    var bulleSource = lire(sections['cart-icon-bubble'], '.shopify-section');
    if (bulle && bulleSource) bulle.innerHTML = bulleSource.innerHTML;

    var page = document.querySelector('[data-mc-panier="page"]');
    if (page && sections[page.dataset.sectionId]) {
      var pageSource = lire(sections[page.dataset.sectionId], '[data-mc-panier="page"]');
      if (pageSource) page.innerHTML = pageSource.innerHTML;
    }

    garderPaliers(anciensPaliers);
    reserverSuggestions();
    rouvrirReplis(ouverts);
    glisserRemplissage(avances);
    rendreFocus(repere);
    calerPaliers();
    celebrer(avant);
    verifierCodes(codes, relireCodesApres);
    document.querySelectorAll('[data-mc-panier]').forEach(function (zone) {
      if (zone.getAttribute('data-mc-panier') === 'tiroir' && !(tiroir && tiroir.classList.contains('active'))) return;
      chargerSuggestions(zone);
    });
    nettoyerPriorite();
  }

  // Traitement prioritaire (Valentin, 23-09) : la case ajoute ou retire le
  // produit service choisi dans Paramètres du thème > Panier. Sa ligne n'est
  // pas affichée (mc-panier-contenu.liquid) ; le rendu de Shopify fait foi
  // pour le total, la case est relue cochée ou non dans ce rendu.
  function basculerPriorite(zone, caseP) {
    var nomZone = zone && zone.getAttribute('data-mc-panier');
    var coche = caseP.checked;
    var variante = caseP.getAttribute('data-variante');
    var cle = caseP.getAttribute('data-cle');
    caseP.setAttribute('aria-busy', 'true');
    return enFile(function () {
      occupe(zone, true);
      var envoi = coche
        ? envoyer(URL_AJOUT, { items: [{ id: Number(variante), quantity: 1 }] })
        : envoyer(URL_CHANGE, { id: cle, quantity: 0 });
      return envoi
        .then(function (etat) {
          appliquerSections(etat.sections, coche ? undefined : etat.discount_codes, coche);
          publier(coche ? 'ajouter' : 'changer', etat);
          annoncer(coche ? 'Traitement prioritaire ajouté.' : 'Traitement prioritaire retiré.');
          var z = document.querySelector('[data-mc-panier="' + nomZone + '"]');
          var c = z && z.querySelector('[data-mc-priorite]');
          if (c) c.focus({ preventScroll: true });
        })
        .catch(function (e) {
          return apresErreur(e, "Le traitement prioritaire n'a pas pu être mis à jour. Réessayez dans un instant.");
        })
        .finally(function () {
          occupe(document.querySelector('[data-mc-panier="' + nomZone + '"]'), false);
        });
    });
  }

  // Mode de livraison choisi dans le dépli « Livraison » (Valentin, 06-10 au
  // soir) : gardé dans l'attribut de panier `_mc_livraison`, et c'est le
  // rendu de Shopify qui recalcule « Livraison » et « Total » (port compris)
  // dans snippets/mc-panier-paliers.liquid. ARGENT : rien n'est calculé ici.
  function choisirLivraison(zone, radio) {
    var nomZone = zone && zone.getAttribute('data-mc-panier');
    var option = radio.closest('.mc-resume__livraison-option');
    if (option) option.setAttribute('aria-busy', 'true');
    return enFile(function () {
      occupe(zone, true);
      return envoyer(URL_MAJ, { attributes: { _mc_livraison: radio.value } })
        .then(function (etat) {
          appliquerSections(etat.sections, etat.discount_codes);
          publier('changer', etat);
          annoncer(radio.value === 'domicile' ? 'Total mis à jour avec la livraison à domicile, à choisir de nouveau au paiement.' : 'Total mis à jour avec la livraison en point relais.');
        })
        .catch(function (e) {
          return apresErreur(e, "Le mode de livraison n'a pas pu être enregistré. Réessayez dans un instant.");
        })
        .finally(function () {
          occupe(document.querySelector('[data-mc-panier="' + nomZone + '"]'), false);
        });
    });
  }

  // La petite fenêtre du choix de livraison se ferme par un clic dehors ou
  // par Échap (avant le tiroir : un premier Échap ferme la fenêtre seule).
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-mc-livraison-repli][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ouvert = document.querySelector('[data-mc-panier] [data-mc-livraison-repli][open]');
    if (!ouvert) return;
    ouvert.open = false;
    var resume = ouvert.querySelector('summary');
    if (resume) resume.focus({ preventScroll: true });
    // Même cible (document, capture) que l'Échap du tiroir, posé après :
    // stopImmediatePropagation, sinon le tiroir se fermait aussi.
    e.stopImmediatePropagation();
    e.preventDefault();
  }, true);

  // Le service resté SEUL au panier (dernier produit retiré) : on le retire,
  // la cliente ne paie pas un traitement prioritaire sans commande. Une seule
  // tentative par état rendu (le drapeau évite une boucle si Shopify refuse).
  var nettoyageEnCours = false;
  function nettoyerPriorite() {
    var seule = document.querySelector('[data-mc-priorite-seule]');
    var cle = seule && seule.getAttribute('data-mc-priorite-seule');
    if (!cle || nettoyageEnCours) return;
    nettoyageEnCours = true;
    enFile(function () {
      return envoyer(URL_CHANGE, { id: cle, quantity: 0 })
        .then(function (etat) {
          appliquerSections(etat.sections, etat.discount_codes);
          publier('changer', etat);
        })
        .catch(function () {})
        .finally(function () { nettoyageEnCours = false; });
    });
  }

  function publier(source, donnees) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mc-panier', cartData: donnees });
    }
  }

  function envoyer(url, corps) {
    corps.sections = sectionsVoulues();
    corps.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    }).then(function (r) {
      // 429 (« Too many attempts ») et 5xx : une panne, pas un refus métier.
      // Le texte anglais de Shopify ne s'affiche pas ; l'appelant donne le
      // sien en français (RELECTURE-3.md, R3). Les 4xx métier (422 stock)
      // gardent la description de Shopify, en français sur cette boutique.
      if (r.status === 429 || r.status >= 500) throw new Error('panne du panier : ' + r.status);
      return r.json().then(function (json) {
        if (!r.ok || json.status) {
          var err = new Error(json.description || json.message || 'Erreur du panier');
          err.shopify = true;
          throw err;
        }
        return json;
      });
    });
  }

  function occupe(zone, oui) {
    if (!zone) return;
    zone.classList.toggle('is-occupe', oui);
    zone.setAttribute('aria-busy', oui ? 'true' : 'false');
  }

  // ARGENT : après TOUTE réponse d'erreur, on se recale sur le serveur AVANT
  // de montrer le message. Un 422 de stock n'est pas un
  // « rien n'a changé » : Shopify a pu mettre la ligne au maximum disponible.
  // Si le recalage lui-même échoue, son message (« Rechargez la page ») est
  // le plus utile : on ne l'écrase pas par la description brute de l'erreur.
  function apresErreur(e, texteReseau) {
    var texte = e && e.shopify ? e.message : texteReseau;
    return rafraichir().then(function (recale) { if (recale) montrerErreur(null, texte); });
  }

  function changer(zone, rep, quantite) {
    return enFile(function () {
      var ligne = retrouverLigne(rep, quantite === 0);
      if (!ligne) {
        delete enAttente[cleAttente(rep)];
        if (quantite === 0) delete retraitsEnFile[rep.cle];
        return rafraichir();
      }
      occupe(zone, true);
      return envoyer(URL_CHANGE, { id: ligne.getAttribute('data-cle'), quantity: quantite })
        .then(function (etat) {
          appliquerSections(etat.sections, etat.discount_codes);
          publier('changer', etat);
          annoncer(quantite === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour : ' + quantite + '.');
        })
        .catch(function (e) {
          return apresErreur(e, 'Le panier ne répond pas. Réessayez dans un instant.');
        })
        .finally(function () {
          if (enAttente[cleAttente(rep)] === quantite) delete enAttente[cleAttente(rep)];
          if (quantite === 0) delete retraitsEnFile[rep.cle];
          occupe(document.querySelector('[data-mc-panier="' + (zone && zone.getAttribute('data-mc-panier')) + '"]'), false);
        });
    });
  }

  function ajouter(zone, variante, bouton) {
    var nomZone = zone && zone.getAttribute('data-mc-panier');
    return enFile(function () {
      if (bouton) bouton.setAttribute('aria-busy', 'true');
      return envoyer(URL_AJOUT, { items: [{ id: Number(variante), quantity: 1 }] })
        .then(function (etat) {
          // /cart/add.js ne rend pas discount_codes : une lecture de /cart.js
          // après le rendu ; si elle échoue, les codes connus restent affichés.
          appliquerSections(etat.sections, undefined, true);
          publier('ajouter', etat);
          annoncer('Produit ajouté au panier.');
          // Le focus va sur la ligne du produit ajouté.
          var z = document.querySelector('[data-mc-panier="' + nomZone + '"]');
          var ligne = z && z.querySelector('[data-mc-ligne][data-variante="' + variante + '"]');
          // Le NOM de la ligne ajoutée, pas « + » : un second Entrée (« rien ne
          // s'est passé ») ajoutait une deuxième unité (RELECTURE-COMPACT-3.md, F1).
          var cible = ligne && ligne.querySelector('.mc-ligne__nom');
          if (cible) cible.focus({ preventScroll: false });
        })
        .catch(function (e) {
          return apresErreur(e, "Ce produit n'a pas pu être ajouté. Réessayez dans un instant.");
        })
        .finally(function () { if (bouton) bouton.removeAttribute('aria-busy'); });
    });
  }

  // ---------- Codes de réduction ----------
  // ARGENT. Un code peut entrer dans le panier sans passer par le champ (lien
  // de newsletter /discount/CODE) ou cesser de s'appliquer après un « moins ».
  // On lit donc les codes dans le panier Shopify (`discount_codes`) :
  // - un code du panier qui ne s'applique pas est affiché, avec « Retirer » ;
  // - un code ACCEPTE mais sans remise sur les prix (livraison offerte,
  //   FRANCO par exemple) n'est pas dans cart.discount_applications avant le
  //   paiement, donc pas rendu par le Liquid : il est écrit ici, « Code X
  //   appliqué · Retirer » (RELECTURE-1.md, D2). ARGENT : rien n'est dit du
  //   port. Shopify ne rend AUCUN signal avant le paiement qui distingue un
  //   code de livraison d'un code de commande (`discount_codes` ne porte que
  //   `code` et `applicable`) ; en déduire « livraison offerte » promettait
  //   un port sur un code de commande saisi en minuscules (RELECTURE-2.md,
  //   N1, N5). La barre des paliers ne parle donc jamais des codes ;
  // - la casse : Shopify garde le code tel que saisi dans `discount_codes`
  //   et rend son titre en MAJUSCULES dans `discount_applications`. On envoie
  //   le code en majuscules et on compare en majuscules des deux côtés : un
  //   code n'est affiché qu'une fois ;
  // - saisir un nouveau code GARDE les codes déjà présents ;
  // - seul le code qu'on vient de saisir est retiré s'il est refusé.
  // Une lecture par action (RELECTURE-1.md, D10 ; RELECTURE-2.md, N2) : les
  // réponses de /cart/change.js et /cart/update.js portent `discount_codes`
  // et alimentent verifierCodes ; /cart/add.js ne les porte PAS (ses clés :
  // items, sections), donc après un ajout, une lecture de /cart.js ; après
  // un rendu de sections (rafraichir) et à l'ouverture du tiroir, une
  // lecture aussi.

  // Dernière liste de codes lue avec succès. Jamais remise à null : si une
  // lecture échoue, l'écran garde le dernier état connu et le dit, plutôt que
  // de faire disparaître un code (RELECTURE-3.md, R1).
  var codesConnus = null;
  var MESSAGE_MAJ = 'Panier en cours de mise à jour, réessayez dans un instant.';

  function lirePanier() {
    return fetch(URL_PANIER + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('lecture du panier : ' + r.status);
        return r.json();
      })
      .then(function (panier) { codesConnus = panier.discount_codes || []; return panier; });
  }

  function codesDuPanier() {
    return lirePanier().then(function (panier) { return panier.discount_codes || []; });
  }

  function boutonRetirerCode(code) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mc-code__retirer';
    b.setAttribute('data-mc-action', 'retirer-code');
    b.setAttribute('data-code', code);
    b.setAttribute('aria-label', 'Retirer le code ' + code);
    b.textContent = 'Retirer';
    return b;
  }

  // Codes acceptés par Shopify que le Liquid n'a pas rendus (aucune remise
  // de prix : livraison offerte). Écrits dans chaque zone ; la barre des
  // paliers n'en dit rien (RELECTURE-2.md, N1).
  function montrerCodesLibres(codes) {
    var acceptes = codes.filter(function (c) { return c.applicable; });
    document.querySelectorAll('[data-mc-panier]').forEach(function (zone) {
      var boite = zone.querySelector('[data-mc-code-libres]');
      if (!boite) return;
      // Codes déjà rendus par le Liquid (majuscules), comparés en majuscules.
      var rendus = Array.prototype.map.call(zone.querySelectorAll('[data-mc-code-applique]:not(.mc-code__etat--libre)'), function (el) {
        return (el.getAttribute('data-mc-code-applique') || '').toUpperCase();
      });
      var vus = {};
      var libres = acceptes.filter(function (c) {
        var maj = c.code.toUpperCase();
        if (rendus.indexOf(maj) !== -1 || vus[maj]) return false;
        vus[maj] = true;
        return true;
      });
      boite.innerHTML = '';
      libres.forEach(function (c) {
        var maj = c.code.toUpperCase();
        var p = document.createElement('p');
        p.className = 'mc-code__etat mc-code__etat--libre';
        p.setAttribute('data-mc-code-applique', maj);
        var t = document.createElement('span');
        t.innerHTML = 'Code <strong></strong> appliqué';
        t.querySelector('strong').textContent = maj;
        p.appendChild(t);
        p.appendChild(boutonRetirerCode(c.code));
        boite.appendChild(p);
      });
      boite.hidden = libres.length === 0;
      // ARGENT : un code de livraison accepté (code « libre ») peut offrir le
      // port au paiement ; le Total ne doit alors plus l'ajouter
      // (RELECTURE-ARGENT-LIVRAISON.md, A2). Le Liquid rend les deux montants.
      var encart = zone.querySelector('.mc-panier__resume');
      if (encart) encart.classList.toggle('mc-resume--code-livraison', libres.length > 0);
    });
  }

  function montrerRefus(texte) {
    document.querySelectorAll('[data-mc-code-refus]').forEach(function (el) {
      el.textContent = texte;
      el.hidden = !texte;
    });
  }

  var dernierRefus = '';

  // `codes` : la liste `discount_codes` d'une réponse du panier. Absente, on
  // reprend la dernière connue ; inconnue, on lit /cart.js.
  // `codes` : liste `discount_codes` d'une réponse du panier ; `relire` :
  // une lecture de /cart.js (après un ajout, un rendu de sections, à
  // l'ouverture). Sinon la dernière liste connue. Si la lecture échoue, la
  // dernière liste connue est réaffichée et la mise à jour annoncée.
  function verifierCodes(codes, relire) {
    var source;
    if (Array.isArray(codes)) source = Promise.resolve((codesConnus = codes));
    else if (relire || !codesConnus) source = codesDuPanier().catch(function () { montrerErreur(null, MESSAGE_MAJ); return codesConnus || []; });
    else source = Promise.resolve(codesConnus);
    return source.then(function (liste) {
      var enSuspens = liste.filter(function (c) { return !c.applicable; });
      document.querySelectorAll('[data-mc-code-attente]').forEach(function (boite) {
        boite.innerHTML = '';
        enSuspens.forEach(function (c) {
          var p = document.createElement('p');
          p.className = 'mc-code__attente';
          var t = document.createElement('span');
          t.textContent = 'Le code ' + c.code + " est dans votre panier, mais ne s'applique pas pour l'instant (conditions non remplies).";
          p.appendChild(t);
          p.appendChild(boutonRetirerCode(c.code));
          boite.appendChild(p);
        });
        boite.hidden = enSuspens.length === 0;
      });
      montrerCodesLibres(liste);
      if (dernierRefus) montrerRefus(dernierRefus);
    }).catch(function () {});
  }

  function saisirCode(nouveau) {
    nouveau = String(nouveau).trim().toUpperCase();
    return enFile(function () {
      dernierRefus = '';
      return codesDuPanier()
        .then(function (codes) {
          var liste = codes.map(function (c) { return c.code; });
          if (liste.map(function (c) { return c.toUpperCase(); }).indexOf(nouveau.toUpperCase()) === -1) liste.push(nouveau);
          return envoyer(URL_MAJ, { discount: liste.join(',') }).then(function (etat) {
            var lui = (etat.discount_codes || []).filter(function (c) { return c.code.toUpperCase() === nouveau.toUpperCase(); })[0];
            if (lui && lui.applicable) return { etat: etat, ok: true };
            var gardes = (etat.discount_codes || []).filter(function (c) { return c.code.toUpperCase() !== nouveau.toUpperCase(); }).map(function (c) { return c.code; });
            return envoyer(URL_MAJ, { discount: gardes.join(',') }).then(function (etat2) { return { etat: etat2, ok: false }; });
          });
        })
        .then(function (res) {
          if (!res.ok) {
            dernierRefus = 'Le code ' + nouveau + " ne s'applique pas à ce panier : il est inconnu, expiré, ou ses conditions ne sont pas remplies.";
          }
          appliquerSections(res.etat.sections, res.etat.discount_codes);
          publier('code', res.etat);
          montrerRefus(dernierRefus);
          annoncer(res.ok ? 'Code ' + nouveau + ' appliqué.' : dernierRefus);
        })
        .catch(function (e) {
          return apresErreur(e, "Le code n'a pas pu être vérifié. Réessayez dans un instant.");
        });
    });
  }

  function retirerCode(code) {
    return enFile(function () {
      dernierRefus = '';
      return codesDuPanier()
        .then(function (codes) {
          var restants = codes.map(function (c) { return c.code; }).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
          return envoyer(URL_MAJ, { discount: restants.join(',') });
        })
        .then(function (etat) {
          appliquerSections(etat.sections, etat.discount_codes);
          publier('code', etat);
          montrerRefus('');
          annoncer('Code ' + code + ' retiré.');
        })
        .catch(function (e) {
          return apresErreur(e, "Le code n'a pas pu être retiré. Réessayez dans un instant.");
        });
    });
  }

  // Remet tout d'aplomb depuis le serveur (après une erreur, ou quand le
  // panier a changé ailleurs : app, Standard Actions de Shopify).
  // /cart?sections=... renvoie le JSON du PANIER, sans les sections. Le rendu
  // des sections se demande sur la page courante (Section Rendering API), qui
  // renvoie { id: html }. Sans en-tête Accept: application/json, sinon
  // Shopify renvoie le JSON de la ressource de la page au lieu des sections.
  // Jamais de rechargement de la page (RELECTURE-1.md, D5) : si la page
  // courante ne rend pas les sections (proxy d'app, 404, 429), on redemande
  // depuis l'accueil ; si cela échoue aussi, on garde l'état, on relit
  // /cart.js et on le dit.
  function rendreSections(chemin) {
    var ids = sectionsVoulues();
    return fetch(chemin + (chemin.indexOf('?') === -1 ? '?' : '&') + 'sections=' + ids.join(','))
      .then(function (r) {
        if (!r.ok) throw new Error('rendu des sections : ' + r.status);
        return r.json();
      })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) throw new Error('rendu des sections vide');
        return sections;
      });
  }

  // Les champs quantité reprennent la valeur confirmée par le serveur
  // (data-quantite) : une saisie refusée ne reste pas à l'écran quand le
  // rendu n'a pas pu être redemandé (RELECTURE-2.md, N3).
  function recalerChamps() {
    document.querySelectorAll('[data-mc-ligne]').forEach(function (ligne) {
      var champ = ligne.querySelector('[data-mc-action="saisie"]');
      if (champ && champ.value !== ligne.getAttribute('data-quantite')) champ.value = ligne.getAttribute('data-quantite');
    });
    // La file d'attente n'est pas vidée : un « changer » encore en file
    // repart de la quantité qu'il attend, pas de celle du serveur
    // (RELECTURE-3.md, R6) ; chaque « changer » efface sa propre entrée.
  }

  // Rend true si l'affichage a été recalé sur le serveur. `silencieux` : pas
  // de message si le rendu échoue (l'appelant sait que l'écran est déjà
  // juste, RELECTURE-2.md, N4).
  // `codes` : liste déjà lue par l'appelant (aucune lecture de plus) ; sinon
  // une lecture de /cart.js après le rendu.
  function rafraichir(silencieux, codes) {
    return rendreSections(window.location.pathname)
      .catch(function () { return rendreSections(routes.root_url || '/'); })
      .then(function (sections) { appliquerSections(sections, Array.isArray(codes) ? codes : undefined, !Array.isArray(codes)); return true; })
      .catch(function () {
        recalerChamps();
        // L'écran garde le dernier état connu (lignes, total, codes connus).
        verifierCodes(codesConnus || []);
        if (!silencieux) montrerErreur(null, "Le panier a changé, mais l'affichage n'a pas pu être actualisé. Rechargez la page pour voir le total à jour.");
        return false;
      });
  }

  // Un ajout fait par le thème (product-form : fiche, sticky du pilote, quick-add) arrive
  // hors de la file. On l'affiche tout de suite (le tiroir s'ouvre sans
  // attendre), puis on se recale sur le serveur DANS la file : si sa réponse
  // était plus ancienne qu'un « + » passé entre-temps, c'est le serveur qui
  // gagne.
  function appliquerExterne(sections) {
    appliquerSections(sections, codesConnus || []);
    // Les sections reçues sont justes (rendues par Shopify à l'instant) : si
    // le recalage échoue, aucun message qui dirait le contraire.
    return enFile(function () { return rafraichir(true); });
  }

  // ---------- « Compléter sa cure » ----------

  function chargerSuggestions(racine) {
    if (!racine) return;
    var boite = racine.querySelector('[data-mc-suggestions]');
    if (!boite) return;
    if (!boite.dataset.produit || !boite.dataset.url) { poser(boite, ''); return; }
    var cle = boite.dataset.produit + '|' + boite.dataset.dansPanier + '|' + (boite.dataset.source || '');

    if (cacheSuggestions[cle] !== undefined) {
      poser(boite, cacheSuggestions[cle]);
      return;
    }

    function demander(intention) {
      var url = boite.dataset.url + '?product_id=' + encodeURIComponent(boite.dataset.produit) +
        '&limit=10&intent=' + intention + '&section_id=mc-panier-suggestions';
      return fetch(url).then(lireReponse).then(function (html) {
        var el = lire(html, '.mc-sugg');
        return el && el.querySelector('.mc-sugg__carte') ? el.innerHTML : '';
      });
    }

    // Une réponse en erreur (429, 5xx) n'est PAS « aucune suggestion » : elle
    // passe par le .catch, rien n'est mis en cache, on redemandera au rendu
    // suivant (RELECTURE-COMPACT-3.md, G5). Un 404 vaut « rien ».
    function lireReponse(r) {
      if (r.ok) return r.text();
      if (r.status === 404) return '';
      throw new Error('suggestions : ' + r.status);
    }

    // Réglage « Même catégorie » : la collection du produit du panier, puis
    // les recommandations si elle ne donne rien.
    function demanderCollection() {
      if (boite.dataset.source !== 'collection' || !boite.dataset.collection) return Promise.resolve('');
      var url = '/collections/' + encodeURIComponent(boite.dataset.collection) +
        '?sort_by=best-selling&section_id=mc-panier-suggestions';
      return fetch(url).then(lireReponse).then(function (html) {
        var el = lire(html, '.mc-sugg');
        return el && el.querySelector('.mc-sugg__carte') ? el.innerHTML : '';
      });
    }

    demanderCollection()
      .then(function (html) { return html || demander('complementary'); })
      .then(function (html) { return html || demander('related'); })
      .then(function (html) {
        cacheSuggestions[cle] = html;
        // Le panier a pu être remplacé pendant la requête : on repart du
        // document, pas de l'élément capturé.
        document.querySelectorAll('[data-mc-suggestions]').forEach(function (b) {
          if (b.dataset.produit + '|' + b.dataset.dansPanier + '|' + (b.dataset.source || '') === cle) poser(b, html);
        });
      })
      .catch(function () {
        // Requête ratée : pas de suggestions, et surtout plus de place
        // réservée vide (non mis en cache : on réessaiera au prochain rendu).
        document.querySelectorAll('[data-mc-suggestions][data-attente]').forEach(function (b) {
          if (b.dataset.produit + '|' + b.dataset.dansPanier + '|' + (b.dataset.source || '') === cle) poser(b, '');
        });
      });
  }

  // La place du bloc est réservée tant que la requête court (data-attente,
  // posé par mc-panier-contenu.liquid) : on la rend ici, qu'il y ait des
  // suggestions ou non.
  // Hauteur du dernier bloc posé, par zone : la place réservée du rendu
  // suivant la reprend, au lieu d'une valeur fixe calée sur un seul écran
  // (RELECTURE-COMPACT-3.md, G4).
  var hauteursSugg = {};

  function reserverSuggestions() {
    document.querySelectorAll('[data-mc-suggestions][data-attente]').forEach(function (b) {
      var zone = b.closest('[data-mc-panier]');
      var h = zone && hauteursSugg[zone.getAttribute('data-mc-panier')];
      if (h) b.style.minHeight = h + 'px';
    });
  }

  function poser(boite, html) {
    boite.removeAttribute('data-attente');
    boite.style.removeProperty('min-height');
    if (!html) {
      boite.hidden = true;
      return;
    }
    if (boite.getAttribute('data-pose') !== '1') {
      boite.innerHTML = html;
      boite.setAttribute('data-pose', '1');
    }
    boite.hidden = false;
    var liste = boite.querySelector('[data-mc-sugg-liste]');
    requestAnimationFrame(function () {
      if (liste) majFleches(liste);
      var zone = boite.closest('[data-mc-panier]');
      if (zone && boite.offsetHeight) hauteursSugg[zone.getAttribute('data-mc-panier')] = boite.offsetHeight;
    });
  }

  // ---------- Écouteurs ----------

  // ---------- Slider « Compléter votre cure » ----------

  function majFleches(liste) {
    var bloc = liste.closest('[data-mc-suggestions]');
    if (!bloc) return;
    var max = liste.scrollWidth - liste.clientWidth - 2;
    bloc.querySelectorAll('[data-mc-sugg-fleche]').forEach(function (f) {
      var sens = Number(f.getAttribute('data-mc-sugg-fleche'));
      f.disabled = sens < 0 ? liste.scrollLeft <= 2 : liste.scrollLeft >= max;
    });
    var fleches = bloc.querySelector('.mc-sugg__fleches');
    if (fleches) fleches.hidden = max <= 0;
  }

  document.addEventListener('click', function (e) {
    var fleche = e.target.closest && e.target.closest('[data-mc-sugg-fleche]');
    if (!fleche) return;
    var liste = fleche.closest('[data-mc-suggestions]').querySelector('[data-mc-sugg-liste]');
    var carte = liste.querySelector('.mc-sugg__carte');
    var pas = carte ? carte.getBoundingClientRect().width + parseFloat(getComputedStyle(liste).columnGap || 0) : liste.clientWidth;
    liste.scrollBy({ left: Number(fleche.getAttribute('data-mc-sugg-fleche')) * pas, behavior: 'smooth' });
  });

  // Glisser à la SOURIS (le doigt défile nativement : overflow-x + snap).
  // Le glisser part de n'importe où dans la liste, image comprise. Un clic qui
  // suit un vrai glisser (plus de 6 px) est avalé : il n'ajoute rien au panier
  // et n'ouvre pas la fiche.
  var glisser = null;
  var avalerClic = false;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var liste = e.target.closest && e.target.closest('[data-mc-sugg-liste]');
    if (!liste) return;
    glisser = { liste: liste, x: e.clientX, depart: liste.scrollLeft, bouge: false, id: e.pointerId };
    avalerClic = false;
  });

  document.addEventListener('pointermove', function (e) {
    if (!glisser || e.pointerId !== glisser.id) return;
    var dx = e.clientX - glisser.x;
    if (!glisser.bouge && Math.abs(dx) > 6) {
      glisser.bouge = true;
      glisser.liste.classList.add('is-glisse');
    }
    if (glisser.bouge) {
      e.preventDefault();
      glisser.liste.scrollLeft = glisser.depart - dx;
    }
  });

  function finGlisser() {
    if (!glisser) return;
    if (glisser.bouge) {
      avalerClic = true;
      var liste = glisser.liste;
      // Rendre l'aimantation APRÈS la dernière position : la liste se cale
      // sur la carte la plus proche.
      requestAnimationFrame(function () {
        liste.classList.remove('is-glisse');
        majFleches(liste);
      });
      setTimeout(function () { avalerClic = false; }, 400);
    }
    glisser = null;
  }
  document.addEventListener('pointerup', finGlisser);
  document.addEventListener('pointercancel', finGlisser);

  window.addEventListener('click', function (e) {
    if (!avalerClic) return;
    if (!(e.target.closest && e.target.closest('[data-mc-sugg-liste]'))) return;
    e.preventDefault();
    e.stopPropagation();
    avalerClic = false;
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[data-mc-sugg-liste]')) e.preventDefault();
  });

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mc-sugg-liste]')) majFleches(e.target);
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-mc-sugg-liste]').forEach(majFleches);
  });

  document.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('[data-mc-panier] [data-mc-action]');
    if (!bouton || bouton.disabled || bouton.getAttribute('aria-disabled') === 'true' || bouton.getAttribute('aria-busy') === 'true') return;
    var zone = bouton.closest('[data-mc-panier]');
    var action = bouton.getAttribute('data-mc-action');
    var ligne = bouton.closest('[data-mc-ligne]');

    if (ligne && (action === 'moins' || action === 'plus' || action === 'retirer')) {
      e.preventDefault();
      var champ = ligne.querySelector('[data-mc-action="saisie"]');
      var pas = champ ? parseInt(champ.step, 10) || 1 : 1;
      var rep = repereLigne(ligne);
      var cle = cleAttente(rep);
      var actuelle = cle in enAttente ? enAttente[cle] : parseInt(ligne.getAttribute('data-quantite'), 10) || 0;
      var min = champ ? parseInt(champ.min, 10) || 1 : 1;
      var voulue = action === 'retirer' ? 0 : action === 'plus' ? actuelle + pas : actuelle - pas;
      if (action === 'moins' && voulue < min) return;
      // Retrait déjà en file pour CETTE ligne (sa clé Shopify) : un double clic
      // ou un second Entrée ne part pas une deuxième fois (RELECTURE-COMPACT-4.md
      // H1, RELECTURE-COMPACT-5.md H2). Effacé quand le retrait a fini.
      if (action === 'retirer') {
        if (retraitsEnFile[rep.cle]) return;
        retraitsEnFile[rep.cle] = true;
      }
      enAttente[cle] = voulue;
      if (champ && voulue > 0) champ.value = voulue;
      changer(zone, rep, voulue);
    } else if (action === 'ajouter') {
      e.preventDefault();
      ajouter(zone, bouton.getAttribute('data-variante'), bouton);
    } else if (action === 'retirer-code') {
      e.preventDefault();
      retirerCode(bouton.getAttribute('data-code'));
    }
  });

  document.addEventListener('change', function (e) {
    var champ = e.target;
    if (!champ.closest) return;

    if (champ.matches('[data-mc-panier] [data-mc-priorite]')) {
      basculerPriorite(champ.closest('[data-mc-panier]'), champ);
      return;
    }

    if (champ.matches('[data-mc-panier] [data-mc-livraison-choix]')) {
      if (!champ.checked) return;
      // La fenêtre se referme dès qu'on choisit (Valentin, 06-10 au soir :
      // « dès que tu cliques, ça se referme ») ; le focus revient sur la ligne
      // « Livraison », qui le garde après le rendu.
      var fenetre = champ.closest('[data-mc-livraison-repli]');
      if (fenetre) {
        fenetre.open = false;
        var ligneLivraison = fenetre.querySelector('summary');
        if (ligneLivraison) ligneLivraison.focus({ preventScroll: true });
      }
      choisirLivraison(champ.closest('[data-mc-panier]'), champ);
      return;
    }

    if (champ.matches('[data-mc-panier] [data-mc-action="saisie"]')) {
      var ligne = champ.closest('[data-mc-ligne]');
      var voulue = parseInt(champ.value, 10);
      var min = parseInt(champ.min, 10) || 1;
      if (isNaN(voulue) || voulue < min) {
        champ.value = ligne.getAttribute('data-quantite');
        return;
      }
      if (champ.max && voulue > parseInt(champ.max, 10)) voulue = parseInt(champ.max, 10);
      if (String(voulue) === ligne.getAttribute('data-quantite')) return;
      var repSaisie = repereLigne(ligne);
      enAttente[cleAttente(repSaisie)] = voulue;
      changer(champ.closest('[data-mc-panier]'), repSaisie, voulue);
    }
  });

  // Entrée dans le champ quantité : valider sans envoyer un formulaire.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var champ = e.target;
    if (champ.matches && champ.matches('[data-mc-panier] [data-mc-action="saisie"]')) {
      e.preventDefault();
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-mc-code-formulaire]')) return;
    e.preventDefault();
    var code = (form.querySelector('input[name="code"]').value || '').trim();
    if (!code) return;
    saisirCode(code);
  });

  // Le panier a changé ailleurs (Standard Actions de Shopify, une app) :
  // on redemande le rendu. Les ajouts du thème (product-form) passent déjà
  // par renderContents du tiroir.
  // PUB_SUB_EVENTS est une `const` globale de constants.js : elle n'est PAS
  // une propriété de window (window.PUB_SUB_EVENTS vaut undefined).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (!evt || evt.source === 'mc-panier' || evt.source === 'product-form') return;
      enFile(rafraichir);
    });
    // Un ajout REFUSÉ depuis une carte produit ou la fiche (stock déjà tout
    // au panier, produit épuisé) : le tiroir s'ouvre, recalé sur le serveur,
    // avec le message de Shopify.
    subscribe(PUB_SUB_EVENTS.cartError, function (evt) {
      if (!evt || evt.source === 'mc-panier') return;
      var texte = (typeof evt.errors === 'string' && evt.errors) || evt.message || "Ce produit n'a pas pu être ajouté.";
      enFile(function () {
        return rafraichir().then(function (recale) {
          var tiroir = document.querySelector('cart-drawer');
          if (tiroir && typeof tiroir.open === 'function') tiroir.open(document.activeElement);
          // Recalage raté : son message « Rechargez la page » reste (R4).
          if (recale) montrerErreur(null, texte);
        });
      });
    });
  }

  window.addEventListener('resize', function () { calerPaliers(); });

  // Ouverture du tiroir : UNE lecture de /cart.js. Si le total lu diffère du
  // total affiché (code posé par un lien dans un autre onglet, app), le rendu
  // est redemandé avec ces codes : un code ne s'affiche « appliqué » que si
  // le total le reflète (RELECTURE-3.md, R2). Lecture ratée : dernier état
  // connu gardé et annoncé.
  function synchroniser() {
    var avantCodes = codesConnus;
    return lirePanier()
      .then(function (panier) {
        var affiche = document.querySelector('cart-drawer [data-mc-panier-contenu]');
        var total = affiche ? Number(affiche.getAttribute('data-total')) : NaN;
        var nb = affiche ? Number(affiche.getAttribute('data-nb-articles')) : NaN;
        if (total !== panier.total_price || nb !== panier.item_count) {
          // Les codes lus ne sont montrés qu'avec le rendu qui les reflète.
          codesConnus = avantCodes;
          return enFile(function () {
            return rafraichir(false, panier.discount_codes || []);
          });
        }
        return verifierCodes(panier.discount_codes || []);
      })
      .catch(function () {
        montrerErreur(null, MESSAGE_MAJ);
        return verifierCodes(codesConnus || []);
      });
  }

  function relireCodes() {
    return synchroniser();
  }

  window.McPanier = {
    relireCodes: relireCodes,
    synchroniser: synchroniser,
    appliquerSections: appliquerSections,
    appliquerExterne: appliquerExterne,
    chargerSuggestions: chargerSuggestions,
    calerPaliers: calerPaliers,
    verifierCodes: verifierCodes,
    rafraichir: rafraichir,
  };

  calerPaliers();
  verifierCodes();
  nettoyerPriorite();

  // ---------- Compte à rebours (option du thème, porté de Rue des Plantes) ----------
  // ⚠️ Ne réserve rien : le panier Shopify n'expire pas. Le temps court depuis
  // la première ouverture et repart à zéro une fois écoulé.
  (function () {
    var CLE = 'mc-panier-rebours-fin';
    function fin(minutes) {
      var maintenant = Date.now();
      var f = 0;
      try { f = parseInt(localStorage.getItem(CLE), 10) || 0; } catch (e) {}
      if (!f || f <= maintenant) {
        f = maintenant + minutes * 60000;
        try { localStorage.setItem(CLE, String(f)); } catch (e) {}
      }
      return f;
    }
    function tic() {
      document.querySelectorAll('[data-mc-rebours]').forEach(function (el) {
        var minutes = parseInt(el.dataset.minutes, 10) || 15;
        var reste = Math.max(0, Math.round((fin(minutes) - Date.now()) / 1000));
        var m = Math.floor(reste / 60);
        var s = reste % 60;
        var champ = el.querySelector('[data-mc-rebours-temps]');
        if (champ) champ.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      });
    }
    setInterval(tic, 1000);
    tic();
  })();

  // Page panier : les suggestions se chargent tout de suite.
  var page = document.querySelector('[data-mc-panier="page"]');
  if (page) chargerSuggestions(page);
})();
